import { Main } from "./main";
import "styles/playlist.css";

export const Playlist = () => {
  return (
    <>
      <Main />
    </>
  );
};
